import styled from "styled-components";
import eiduHeader from "assets/eidu/eidu26_header_desktop.png";

/** Banner EIDU 2026 encima del formulario de inscripción. */
export function EiduHero() {
  return (
    <Hero>
      <img
        src={eiduHeader}
        alt="EIDU 2026 — V Encuentro Internacional en Docencia Universitaria. Innovar para incluir: pedagogías sin barreras"
      />
    </Hero>
  );
}

const Hero = styled.div`
  width: 100%;
  margin: 0 0 56px;
  line-height: 0;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;
